export default __webpack_public_path__ + "static/media/photo--sm--ayaka2.94e8a455.jpg";